export default "__VITE_ASSET__DVbhA$uG__"